import React from "react";
import { useTranslation } from "react-i18next";
import { Search } from "lucide-react";
import { NOTIFICATION_TYPES } from "../../../mock";
import style from "./index.module.scss";

const NotificationFilter = ({
  selectedType,
  selectedReadStatus,
  onTypeChange,
  onReadStatusChange,
  searchQuery,
  onSearchChange,
}) => {
  const { t } = useTranslation();
  const notificationTypes = NOTIFICATION_TYPES(t);

  const typeOptions = [
    { key: "all", name: t("notificationPage.filters.all") },
    ...Object.values(notificationTypes),
  ];

  const statusOptions = [
    { key: "all", name: t("notificationPage.filters.all") },
    { key: "unread", name: t("notificationPage.filters.unread") },
    { key: "read", name: t("notificationPage.filters.read") },
  ];

  const handleTypeChange = (typeKey) => {
    onTypeChange(typeKey);
  };

  const handleStatusChange = (statusKey) => {
    onReadStatusChange(statusKey);
  };

  return (
    <div className={style.filterSidebar}>
      <div className={style.filterHeader}>
        <h2 className={style.title}>{t("notificationPage.filters.title")}</h2>
      </div>

      {/* Search Section */}
      <div className={style.filterSection}>
        <h3 className={style.sectionTitle}>{t("notificationPage.filters.search")}</h3>
        <div className={style.searchContainer}>
          <div className={style.searchIcon}>
            <Search size={16} />
          </div>
          <input
            type="text"
            className={style.searchInput}
            placeholder={t("notificationPage.filters.searchPlaceholder")}
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
      </div>

      {/* Type Section */}
      <div className={style.filterSection}>
        <h3 className={style.sectionTitle}>{t("notificationPage.filters.type")}</h3>
        <div className={style.checkboxGroup}>
          {typeOptions.map((type) => (
            <label key={type.key} className={style.checkboxLabel}>
              <div className={style.checkboxWrapper}>
                <input
                  type="checkbox"
                  className={style.checkbox}
                  checked={selectedType === type.key}
                  onChange={() => handleTypeChange(type.key)}
                />
                <div className={style.checkboxCustom}>
                  {selectedType === type.key && (
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.6666 3.5L5.24992 9.91667L2.33325 7"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </div>
              </div>
              <span className={style.checkboxText}>{type.name}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Status Section */}
      <div className={style.filterSection}>
        <h3 className={style.sectionTitle}>{t("notificationPage.filters.status")}</h3>
        <div className={style.checkboxGroup}>
          {statusOptions.map((status) => (
            <label key={status.key} className={style.checkboxLabel}>
              <div className={style.checkboxWrapper}>
                <input
                  type="checkbox"
                  className={style.checkbox}
                  checked={selectedReadStatus === status.key}
                  onChange={() => handleStatusChange(status.key)}
                />
                <div className={style.checkboxCustom}>
                  {selectedReadStatus === status.key && (
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.6666 3.5L5.24992 9.91667L2.33325 7"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </div>
              </div>
              <span className={style.checkboxText}>{status.name}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotificationFilter;
